import { LogisticsType, ProductResponse } from '@/app/types/productServiceType'
import { apiSlice } from './apiSlice'
import { toast } from 'sonner'

export const productSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductServices: builder.query({
      query: () => ({
        url: '/company_products',
        method: 'GET',
      }),
      providesTags: ['ProductServices'],
      transformResponse: async (responseData: ProductResponse) => {
        return responseData
      },
    }),
    addProductServices: builder.mutation({
      query: (products: FormData) => ({
        url: '/company_products',
        method: 'POST',
        body: products,
      }),
      invalidatesTags: ['ProductServices'],
      transformErrorResponse: async (responseData: any) => {
        toast.error(responseData?.data?.messages?.[0])
        return responseData
      },
    }),
    updateProductServices: builder.mutation({
      query: (data: { id: number; products: FormData }) => ({
        url: `/company_products/${data.id}`,
        method: 'PATCH',
        body: data.products,
      }),
      invalidatesTags: ['ProductServices'],
      transformErrorResponse: async (responseData: any) => {
        toast.error(responseData?.data?.messages?.[0])
        return responseData
      },
    }),
    deleteProductServices: builder.mutation({
      query: (id) => ({
        url: `/company_products/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProductServices'],
    }),
    getActivityList: builder.query({
      query: () => '/activities',
      providesTags: ['Activities'],
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
    getLogistics: builder.query({
      query: () => '/logistics',
      providesTags: ['Logistics'],
      transformResponse: async (responseData: {
        status: string
        logistics: LogisticsType
        count: number
      }) => {
        return responseData.logistics
      },
    }),
    addNewLogistics: builder.mutation({
      query: (data: { country_id: number; logistics_type: string }) => ({
        url: `/logistics`,
        method: 'POST',
        body: {
          logistics: {
            country_id: data.country_id,
            logistics_type: data.logistics_type,
          },
        },
      }),
      invalidatesTags: ['Logistics'],
    }),

    removeLogistics: builder.mutation({
      query: (data: number) => ({
        url: `/logistics/${data}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Logistics'],
    }),
  }),
})

export const {
  useGetProductServicesQuery,
  useAddProductServicesMutation,
  useUpdateProductServicesMutation,
  useDeleteProductServicesMutation,
  useGetActivityListQuery,
  useGetLogisticsQuery,
  useAddNewLogisticsMutation,
  useRemoveLogisticsMutation,
} = productSlice
